import signRelationshipChange from './actions/signRelationshipChange';
import signRelationshipCreate from './actions/signRelationshipoCreate';
import signRelationshipDetail from './actions/signRelationshipDetail';
import signRelationshipList from './actions/signRelationshipList';
import getSignRelationship from './getters/getSignRelationship';
import signRelationshipUpload from './mutations/signRelationshipUpload';

const actions = {
    signRelationshipChange,
    signRelationshipCreate,
    signRelationshipDetail,
    signRelationshipList
};

const mutations = {
    signRelationshipUpload
};

const getters = {
    getSignRelationship
};

export default { actions, mutations, getters };
